import Vue from 'vue';
import Router from 'vue-router';
import Index from './pages/Index.vue';
import QuienesSomos from './pages/QuienesSomos.vue';
import Login from './pages/Login.vue';
import MainNavbar from './layout/MainNavbar.vue';
import MainFooter from './layout/MainFooter.vue';
import MainNavbarProfile from './layout/MainNavbarProfile.vue';
import MainNavbarBack from './layout/MainNavbarBack.vue';
import PerfilUsuario from './pages/PerfilUsuario.vue';
import ComerciosAfiliados from './pages/ComerciosAfiliados.vue';
import EditarPerfil from './pages/EditarPerfil.vue';
import Cupones from './pages/Cupones.vue';
import Transacciones from './pages/Transacciones.vue';
import Mensaje from './pages/Mensaje.vue';
import Contrasena from './pages/RecuperarContraseña.vue';
import Privacidad from './pages/Privacidad.vue';
import Condiciones from './pages/Condiciones.vue';

Vue.use(Router);

export default new Router({
  linkExactActiveClass: 'active',
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'index',
      components: { default: Index, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },
    {
      path: '/quienes_somos',
      name: 'quienes_somos',
      components: { default: QuienesSomos, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },{
      path: '/login',
      name: 'login',
      components: { default: Login, header: MainNavbar },
      props: {
        header: { colorOnScroll: 400 }
      }
    },{
      path: '/contrasena',
      name: 'contrasena',
      components: { default: Contrasena, header: MainNavbar },
      props: {
        header: { colorOnScroll: 400 }
      }
    },{
      path: '/PerfilUsuario',
      name: 'perfil_usuario',
      components: { default: PerfilUsuario, header: MainNavbarProfile, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },
    ,{
      path: '/PerfilUsuario/comercios',
      name: 'comercios_afiliados',
      components: { default: ComerciosAfiliados, header: MainNavbarProfile, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },{
      path: '/PerfilUsuario/EditarPerfil',
      name: 'editar_perfil',
      components: { default: EditarPerfil, header: MainNavbarProfile, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },{
      path: '/PerfilUsuario/cupones',
      name: 'cupones',
      components: { default: Cupones, header: MainNavbarProfile, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },{
      path: '/PerfilUsuario/transacciones',
      name: 'transacciones',
      components: { default: Transacciones, header: MainNavbarProfile, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },{
      path: '/privacidad',
      name: 'privacidad',
      components: { default: Privacidad, header: MainNavbarBack, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },{
      path: '/condiciones',
      name: 'condiciones',
      components: { default: Condiciones, header: MainNavbarBack, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },{
      path: '/:mensaje',
      name: 'mensaje',
      components: { default: Mensaje, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    }
  ],
  scrollBehavior: to => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  }
});
